import { useRef } from "react";
import { signal, useSignalEffect } from "@preact/signals-react";
import proxy from "api/proxy";
import CardPromotion from "apps/HotelFrontdesk/house/CardPromotion";
import { ArrowLeftIcon, ArrowRightIcon } from "components/Icons";

const dataExperiences = signal([]);
const canScrollLeft = signal(false);
const canScrollRight = signal(true);

const Experiences = ({ title, transparentLayer = false, handleRecords }) => {
  const scrollRef = useRef(null);

  const getExperiences = async () => {
    const dom = [];
    const fields = [
      "id",
      "promotions.name",
      "promotions.sale_price_w_tax",
      "promotions.list_price",
      "promotions.images",
      "promotions.images.image_url",
      "promotions.description",
    ];
    const { data: dataExp } = await proxy.search("sale.shop", dom, fields);

    if (dataExp) {
      const rawExperiences = dataExp.flatMap((item) => item["promotions."]);
      if (rawExperiences.length === 0) {
        handleRecords(rawExperiences.length);
        return false;
      }
      dataExperiences.value = rawExperiences.map((exp) => ({
        id: exp.id,
        name: exp.name,
        description: exp.description || exp.name,
        price: exp.sale_price_w_tax,
        photo: exp.images?.length ? exp["images."][0]?.image_url : null,
        rating: "⭐⭐⭐⭐⭐",
        discount: exp.list_price
          ? Math.round(
              ((exp.list_price - exp.sale_price_w_tax) / exp.list_price) * 100,
            )
          : 0,
      }));
    }
  };

  const checkScroll = () => {
    if (!scrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
    canScrollLeft.value = scrollLeft > 0;
    canScrollRight.value = scrollLeft + clientWidth < scrollWidth;
  };

  // cargar datos al montar
  useSignalEffect(() => {
    getExperiences();
  });

  // listeners de scroll y resize
  useSignalEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    checkScroll();
    el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  });

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({
      left: -scrollRef.current.offsetWidth,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({
      left: scrollRef.current.offsetWidth,
      behavior: "smooth",
    });
  };

  let startX = 0;
  let scrollStart = 0;

  const handleTouchStart = (e) => {
    startX = e.touches[0].pageX;
    scrollStart = scrollRef.current.scrollLeft;
  };

  const handleTouchMove = (e) => {
    if (!scrollRef.current) return;
    const x = e.touches[0].pageX;
    const walk = startX - x;
    scrollRef.current.scrollLeft = scrollStart + walk;
  };

  if (dataExperiences.value.length === 0) {
    return null;
  }

  return (
    <div className="relative max-w-full mb-8 max-md:px-4">
      {title && (
        <div className="text-4xl text-neutral-600 mb-4">
          <span className="font-bold">Upselling</span>
          <span className=""> / Crosselling</span>
        </div>
      )}

      {canScrollLeft.value && (
        <button
          type="button"
          onClick={scrollLeft}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-md rounded-full p-2 z-10 hover:bg-gray-200"
        >
          <ArrowLeftIcon className="fill-current text-black size-6" />
        </button>
      )}

      <div
        ref={scrollRef}
        className="flex space-x-[20px] overflow-x-auto scroll-smooth no-scrollbar pr-10"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
      >
        {dataExperiences.value.length > 0 &&
          dataExperiences.value.map((pro, idx) => (
            <CardPromotion
              key={idx}
              data={pro}
              handleClick={(data) => console.log(data)}
            />
          ))}
      </div>

      <button
        type="button"
        onClick={scrollRight}
        className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-md rounded-full p-2 z-10 hover:bg-gray-200"
      >
        <ArrowRightIcon className="fill-current text-black size-6" />
      </button>
      {transparentLayer && (
        <div className="w-30 h-full bg-gradient-to-l from-gray-50 from-0% via-transparent via-100% absolute right-0 top-0 pointer-events-none" />
      )}
    </div>
  );
};

export default Experiences;
